import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const CustomerFilters = ({ 
  searchTerm, 
  setSearchTerm, 
  statusFilter, 
  setStatusFilter,
  categoryFilter,
  setCategoryFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onReset,
  totalResults 
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'enterprise', label: 'Enterprise' },
    { value: 'smb', label: 'SMB' },
    { value: 'startup', label: 'Startup' }
  ];

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col md:flex-row md:items-end gap-4">
          {/* Date range */}
          <div className="flex items-end gap-2">
            <div className="flex flex-col gap-1">
              <label className="font-body text-xs text-muted-foreground">From</label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="h-10 rounded-md border border-border bg-background px-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="font-body text-xs text-muted-foreground">To</label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="h-10 rounded-md border border-border bg-background px-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
          </div>

          {/* Search + category */}
          <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="relative">
              <Input
                type="search"
                placeholder="Search customers..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e?.target?.value)}
                className="pl-10"
              />
              <Icon 
                name="Search" 
                size={18} 
                className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
              />
            </div>

            <Select
              options={categoryOptions}
              value={categoryFilter}
              onChange={setCategoryFilter}
              placeholder="Filter by category"
            />
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              onClick={onReset}
              iconName="RotateCcw"
              iconPosition="left"
              size="default"
            >
              Reset
            </Button>
            <div className="caption text-muted-foreground whitespace-nowrap">
              {totalResults} {totalResults === 1 ? 'customer' : 'customers'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerFilters;